<div class="confirm-modal" role="dialog" aria-modal="true">
    <div class="swal-icon swal-icon--warning">
        <span class="swal-icon--warning__body">
        <span class="swal-icon--warning__dot"></span>
        </span>
    </div>
    <div class="swal-title">Are you sure?</div>
    <div class="swal-text">You won't be able to revert this!</div>
    <div class="swal-text mt-2">To confirm please verify your login password</div>
    <form #passwordForm="ngForm" class="mt-4">
        <div class="form-group">
            <input type="password" name="password" class="form-control" placeholder="Confirm Password" ngModel required>
        </div>
    </form>
    <div class="swal-footer">
        <div class="swal-button-container">
            <button class="swal-button swal-button--cancel btn btn-danger mr-4" [disabled]="passwordForm.invalid" (click)="confirmDelete(passwordForm.value)">Confirm</button>
            <button class="swal-button swal-button--confirm btn btn-primary" (click)="closeModal()">Cancel</button>
    </div>
    <div class="swal-button-container">
        
    </div>
    </div>
</div>